import React, { useEffect, useState, useRef } from "react";
import cn from "classnames";

import "./two.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

import { Autoplay, EffectFade, EffectCards } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/bundle';

import Header from "../../components/header";
import Footer from "../../components/footer";

import TwoPage1 from "../../components/twoPage1/twoPage1";
import TwoPage2 from "../../components/twoPage2/twoPage2";
import TwoPage3 from "../../components/twoPage3/twoPage3";
import TwoPage4 from "../../components/twoPage4/twoPage4";
import TwoPage5 from "../../components/twoPage5/twoPage5";

gsap.registerPlugin(ScrollTrigger);
function Two(props) {
  const { setSection, setCurrentDate, anchor } = props;
  const [swiperRef, setSwiperRef] = useState(null);

  const [page, setPage] = useState(false);
  const [initPage, setInitPage] = useState(0);
  const [currentFooter, setCurrentFooter] = useState(0);
  const [trigger, setTrigger] = useState(false);

  const [nextPage, setNextPage] = useState(false);
  const [currentScroll, setCurrentScroll] = useState(0);
  const [currentScroll2, setCurrentScroll2] = useState(0);
  const [load, setLoad] = useState(false);
  const [images, setImages] = useState(0);

  let arr = [false, false, false, false, false];
  let [viewed, setViewed] = useState(arr);

  const setCurrentPage = (status) => {
    
    

    const interval = setInterval(() => {}, 500);

    // if (trigger) {
    if (!page) {
      if (status.status) {
        
        
        setCurrentScroll2(currentScroll);
        
        trigger.disable();

        setTimeout(() => {
          setPage(true);
          setInitPage(status.el);

          let index = status.el - 1;
          setViewed([
            ...viewed.slice(0, index),
            true,
            ...viewed.slice(index + 1),
          ]);
          // initFooter();
        }, 100);
      } else {
        setPage(false);
        setInitPage(0);

        if (status.el === 6) {
          ScrollTrigger.killAll();
          setSection({ section: "two", status: false });
        }
      }
    } else {
      setNextPage(false);

      if (status.status && initPage === status.el) {
        
        setPage(false);
        setInitPage(0);

        setTimeout(() => {
          trigger.enable();
        }, 300);
      } else {
        if (status.el === 6) {
          
          ScrollTrigger.killAll();
          setSection({ section: "two", status: false });
        }
        
        setPage(false);
        setNextPage(true);
        setTimeout(() => {
          let index = status.el - 1;
          setViewed([
            ...viewed.slice(0, index),
            true,
            ...viewed.slice(index + 1),
          ]);
          // initFooter();
          setPage(true);
          setInitPage(status.el);
          if(window.innerWidth < 767){
            if(swiperRef && status.el !== 6){
              swiperRef.slideToLoop(index);
            }  
          }
          // window.scrollTo(0, 0)
        }, 1);
      }
    }
    // }
  };

  useEffect(() => {
    
  }, [images]);

  useEffect(() => {
    if (viewed) {
      for (const [index, value] of viewed.entries()) {
        if (value === false) {
          //     
          //     

          return setCurrentFooter(index + 1);

          //     return false;
        } else {
          setCurrentFooter(6);
        }
      }
    }
    // function initFooter() {

    // }
  }, [viewed]);

  useEffect(() => {
    // if (load) {
    // document.body.classList.add("hide");
    let iteration = 0;

    const spacing = 0.1, // spacing of the cards (stagger)
      snap = gsap.utils.snap(spacing), // we'll use this to snap the playhead on the seamlessLoop
      cards = gsap.utils.toArray(".growth__item"),
      seamlessLoop = buildSeamlessLoop(cards, spacing),
      scrub = gsap.to(seamlessLoop, {
        // we reuse this tween to smoothly scrub the playhead on the seamlessLoop
        totalTime: 0,
        duration: 0.3,
        ease: "power1",
        paused: true,
      }),
      trigger = ScrollTrigger.create({
        // start: 0,
        onEnter(self) {
          // 

          // 
          
          self.scroll(currentScroll);
          setTrigger(self);
          // test();
        },
        onUpdate(self) {
          if (self.progress === 1 && self.direction > 0 && !self.wrapping) {
            wrapForward(self);
            
          } else if (
            self.progress < 1e-5 &&
            self.direction < 0 &&
            !self.wrapping
          ) {
            wrapBackward(self);
            
          } else {
            scrub.vars.totalTime = snap(
              (iteration + self.progress) * seamlessLoop.duration()
            );
            scrub.invalidate().restart(); // to improve performance, we just invalidate and restart the same tween. No need for overwrites or creating a new tween on each update.
            self.wrapping = false;
            
          }
          setCurrentScroll(self.scroll());
          // );
        },
        end: "+=5000",
        pin: ".section",
      });

    function wrapForward(trigger) {
      // when the ScrollTrigger reaches the end, loop back to the beginning seamlessly
      iteration++;
      trigger.wrapping = true;
      trigger.scroll(trigger.start + 1);
    }

    function wrapBackward(trigger) {
      // when the ScrollTrigger reaches the start again (in reverse), loop back to the end seamlessly

      iteration--;
      if (iteration < 0) {
        // to keep the playhead from stopping at the beginning, we jump ahead 10 iterations
        iteration = 6;
        seamlessLoop.totalTime(
          seamlessLoop.totalTime() + seamlessLoop.duration() * 10
        );
        scrub.pause(); // otherwise it may update the totalTime right before the trigger updates, making the starting value different than what we just set above.
      }
      trigger.wrapping = true;
      trigger.scroll(trigger.end - 1);
    }

    function buildSeamlessLoop(items, spacing) {
      // 
      let overlap = Math.ceil(1 / spacing), // number of EXTRA animations on either side of the start/end to accommodate the seamless looping
        // startTime = items.length * spacing + 0.5, // the time on the rawSequence at which we'll start the seamless loop
        startTime = items.length * spacing + 0.5, // the time on the rawSequence at which we'll start the seamless loop
        loopTime = (items.length + overlap) * spacing + 1, // the spot at the end where we loop back to the startTime
        rawSequence = gsap.timeline({ paused: true }), // this is where all the "real" animations live
        seamlessLoop = gsap.timeline({
          // this merely scrubs the playhead of the rawSequence so that it appears to seamlessly loop
          paused: true,
          repeat: -1, // to accommodate infinite scrolling/looping
          onRepeat() {
            // works around a super rare edge case bug that's fixed GSAP 3.6.1
            this._time === this._dur && (this._tTime += this._dur - 0.01);
          },
        }),
        l = items.length + overlap * 2,
        // l = items.length + overlap,
        time = 0,
        i,
        index,
        item;
      // 
      // 
      // set initial state of items
      gsap.set(items, {
        //  yPercent: 0,
        //   y: "-26%",
        opacity: 1,
        scale: 0,
      });

      // now loop through and create all the animations in a staggered fashion. Remember, we must create EXTRA animations at the end to accommodate the seamless looping.
      for (i = 0; i < l; i++) {
        // 
        index = i % items.length;
        item = items[index];
        // 
        time = i * spacing;

        // let num;
        // if (i < 6) {
        //   num = i;
        //   
        // } else if (i === 3) {
        //   // num = 1;

        // } else {
        //   num = 4;
        // }
        // yoyo: true, repeat: 1, ease: "power1.in", immediateRender: false
        rawSequence.fromTo(
          item,
          {
            scale: 0.7,
            zIndex: 1,
            //  yPercent: 12,
            ease: "none",
            y: "-36%",
          },
          {
            onUpdate: setEndAnimation,
            scale: 1,
            zIndex: 100,
            ease: "none",
            // yPercent: 0,
            immediateRender: false,
            y: "0%",
            // repeat: 1,
            // yoyo: true,
          },
          time
        );
        // rawSequence.to(item,  {scale: 0.7, zIndex: 1, y: "-26%", opacity: 1}, time).to(item, { onComplete: test, scale: 1,  zIndex: 100, yPercent: 0, y: "0%",  yoyo: true, onEnter: (e) => {}, opacity: 1 }, time)

        //  .fromTo(item, {yPercent: 0}, {yPercent: 0, duration: 1, ease: "none", immediateRender: false}, time);
        // i <= items.length && seamlessLoop.add('label' + i, time); // we don't really need these, but if you wanted to jump to key spots using labels, here ya go.
      }

      // here's where we set up the scrubbing of the playhead to make it appear seamless.
      rawSequence.time(startTime);
      seamlessLoop
        .to(rawSequence, {
          time: loopTime,
          duration: loopTime - startTime,
          ease: "none",
        })
        .fromTo(
          rawSequence,
          { time: overlap * spacing + 1 },
          {
            time: startTime,
            duration: startTime - (overlap * spacing + 1),
            immediateRender: false,
            ease: "none",
          }
        );
      // 
      return seamlessLoop;
    }

    function setEndAnimation() {
      let maxZIndex = 0;
      let topItem;
      cards.forEach((e) => {
        if (maxZIndex < +e.style.zIndex) {
          maxZIndex = +e.style.zIndex;
          topItem = e;
        }
      });

      if (!topItem.classList.contains("growth__item--hide")) {
        // 
        // 
        cards.forEach((e) => {
          e.classList.remove("growth__item--hide");
          e.classList.remove("growth__item--active");
        });
        // 

        let prevEl = topItem.nextElementSibling;

        if (prevEl) {
          // 
          prevEl.classList.add("growth__item--active");
        } else {
          // 
          // const card = document.querySelector('.growth__item--4');
          // card.classList.add('growth__item--active');
        }
        // 
        //
        if(window.innerWidth > 767){
          topItem.classList.add("growth__item--hide");
        }
      }
    }
    //
    // }
  }, []);

  useEffect(() => {
    
    
    if (anchor && load) {
      let num;

      switch (anchor.years) {
        case 2012:
          num = 1;
          break;
        case 2013:
          num = 2;
          break;
        case 2014:
          num = 3;
          break;
        case 2015:
          num = 4;
          break;
        case 2016:
          num = 5;
          break;
      }
      
      // setTimeout(() => {

      if (anchor.start) {
        setPage(false);
        setInitPage(0);
      } else if (num === undefined) {
        setPage(false);
        setInitPage(0);

        if (anchor.years < 2012 || anchor.years > 2016) {
          
          ScrollTrigger.killAll();
          setSection({ section: "two", status: false });
        }
      } else {
        setCurrentPage({ status: true, el: num });
      }
      // },500)
    }
  }, [anchor, load]);

  useEffect(() => {
    if (page) {
      function animateFrom(elem, direction) {
        direction = direction || 1;
        var x = 0,
          y = direction * 150,
          duration = 1.25,
          scale = 1;
        if (elem.classList.contains("growth-page__img")) {
          // 
          scale = 0.9;
          y = 0;
          duration = 3;
        } else if (elem.closest(".growth-page__img")) {
          scale = 0.9;
          y = 0;
          duration = 3;
        }
        elem.style.transform = "translate3d(" + x + "px, " + y + "px, -1px)";
        elem.style.opacity = "0";
        gsap.fromTo(
          elem,
          { x: x, y: y, z: '1px', scale: scale, autoAlpha: 0 },
          {
            duration: duration,
            x: 0,
            y: 0,
            z: -1,
            scale: 1,
            autoAlpha: 1,
            ease: "expo",
            overwrite: "auto",
          }
        );
      }

      function hide(elem) {
        gsap.set(elem, { autoAlpha: 0 });
      }

      function initImg(elem) {
        if (elem.classList.contains("growth-page__img")) {
          gsap.set(elem, { scale: 0.9 });
        }

        if (elem.closest(".growth-page__img")) {
          gsap.set(elem, { scale: 0.9 });
        }
      }

      gsap.registerPlugin(ScrollTrigger);

      gsap.utils.toArray("._growth-anim").forEach(function (elem) {
        hide(elem);
        initImg(elem);

        ScrollTrigger.create({
          trigger: elem,
          // markers: true,
          start: "top 90%",
          scrub: 0.1,
          onEnter: function (self) {
            animateFrom(elem);
            self.kill();
            // 
          },
        });
      });

      gsap.utils.toArray("._gr-bg").forEach(function (elem) {
        ScrollTrigger.create({
          trigger: elem,
          // markers: true,
          start: "top 90%",
          scrub: 0.1,
          onEnter: function (self) {},
          onUpdate: (self) => {
            gsap.to(elem, { y: +100 * self.progress });
          },
        });
      });

      gsap.utils.toArray("._growth-anim--fade").forEach(function (elem) {
        ScrollTrigger.create({
          trigger: elem,
          // markers: true,
          start: "top 90%",
          scrub: 0.1,
          onEnter: function (self) {
            self.kill();
            gsap.fromTo(
              elem,
              { opacity: 0 },
              {
                duration: 1.25,
                // delay: 1,
                opacity: 1,
                ease: "expo",
                overwrite: "auto",
              }
            );
          },
        });

        gsap.utils.toArray("._footer").forEach(function (elem) {
          ScrollTrigger.create({
            trigger: elem,
            // markers: true,
            start: "top 90%",
            scrub: 0.1,
            onEnter: function (self) {
              // 
              // viewed[initPage].initPage = true;
            },
          });
        });
      });
    }
  }, [page]);

  useEffect(() => {
    getLoadingImg();
  }, []);

  useEffect(() => {
    if (!load) {
      document.body.classList.add("_hide");
    } else {
      document.body.classList.remove("_hide");
    }
  }, [load]);

  function getLoadingImg() {
    let num = 0;
    const imgs = document.querySelectorAll(".section img");
    
    for (let img of imgs) {
      img.onload = function (e) {
        num = num + 1;

        if (num === imgs.length - 1) {
          
        }
      };
    }
    setTimeout(() => {
      setLoad(true);
    }, [5000]);
  }

  return (
    <>
      <div className="two-load">
        {/* <img src="img/two/two-load.png" alt="" /> */}
        <div className="blobs">
          <div className="blob-center"></div>
          <div className="blob"></div>
          <div className="blob"></div>
          <div className="blob"></div>
          <div className="blob"></div>
          <div className="blob"></div>
          <div className="blob"></div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
          <defs>
            <filter id="goo">
              <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="10"
                result="blur"
              />
              <feColorMatrix
                in="blur"
                mode="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                result="goo"
              />
              <feBlend in="SourceGraphic" in2="goo" />
            </filter>
          </defs>
        </svg>
      </div>
      <section
        className={cn(
          "section  page__section",
          page && "section--page",
          nextPage && "section--nextPage",
          !load && "section--hide"
        )}
      >
        <div className="section__container">
          <div className="section__header">
            <Header
              components="two"
              page={page}
              setCurrentDate={setCurrentDate}
            />
          </div>
          <div className="section__content">
            <div className="growth section__growth">
              {window.innerWidth < 768 && (
              <div className="growth__slider">

                <Swiper
                  // modules={[Autoplay, EffectFade]}
                  // spaceBetween={0}
                  // slidesPerView={1}
                  onSwiper={setSwiperRef}
                  effect= {'cards'}
                  modules={[EffectCards]}
                  loop
                  direction={"vertical"}
                  initialSlide={6}
                  cardsEffect={{
                    perSlideOffset: 10,
                    perSlideRotate: 0
                  }}
                >
                  <SwiperSlide>
                    <div
                      className={cn(
                        "growth__item growth__item--1",
                        // initPage === 1 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={(e) => setCurrentPage({ status: true, el: 1, activeIndex: 2 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-1.png"
                            srcSet="img/two/growth-1.png 1x, img/two/growth-1@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2012</span>
                        <h2 className="growth__title">
                          Сколько стоит ваш беспорядок 2.0
                        </h2>
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className={cn(
                        "growth__item growth__item--2",
                        // initPage === 2 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={(e) => setCurrentPage({ status: true, el: 2, activeIndex: 3 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-2.png"
                            srcSet="img/two/growth-2.png 1x, img/two/growth-2@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2013</span>
                        <h2 className="growth__title">
                          Объединение Avito, Slando и OLX
                        </h2>
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className={cn(
                        "growth__item growth__item--3",
                        // initPage === 3 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: true, el: 3, activeIndex: 4 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-3.png"
                            srcSet="img/two/growth-3.png 1x, img/two/growth-3@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2014</span>
                        <h2 className="growth__title">
                          От нового финансового директора до нового фирменного
                          знака
                        </h2>
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className={cn(
                        "growth__item growth__item--4",
                        // initPage === 4 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: true, el: 4, activeIndex: 5 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-4.png"
                            srcSet="img/two/growth-4.png 1x, img/two/growth-4@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>

                        <span className="growth__title-year">2015</span>
                        <h2 className="growth__title">
                          Участник площадки — вся страна
                        </h2>
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className={cn(
                        "growth__item growth__item--5",
                        // initPage === 5 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: true, el: 5, activeIndex: 6 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-5.png"
                            srcSet="img/two/growth-5.png 1x, img/two/growth-5@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2016</span>
                        <h2 className="growth__title">
                          Масштабные обновления: от доставки до приложения
                        </h2>
                      </a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={cn("growth__item growth__item--6")}>
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: false, el: 6, activeIndex: 1 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-6.png"
                            srcSet="img/two/growth-6.png 1x, img/two/growth-6@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                        </div>
                        <span className="growth__title-year">2017-2022</span>
                        <h2 className="growth__title">«Авито» сегодня</h2>
                      </a>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              )}
              <div className="growth__wrap">
                <div className="growth__col">
                  <div className="growth__year">2012</div>
                </div>
                <div className="growth__col">
                  <div className="growth__list">
                    <div className={cn("growth__item growth__item--6")}>
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: false, el: 6 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-6.png"
                            srcSet="img/two/growth-6.png 1x, img/two/growth-6@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                        </div>
                        <span className="growth__title-year">2017-2022</span>
                        <h2 className="growth__title">«Авито» сегодня</h2>
                      </a>
                    </div>

                    <div
                      className={cn(
                        "growth__item growth__item--1",
                        initPage === 1 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={(e) => setCurrentPage({ status: true, el: 1 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-1.png"
                            srcSet="img/two/growth-1.png 1x, img/two/growth-1@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2012</span>
                        <h2 className="growth__title">
                          Сколько стоит ваш беспорядок 2.0
                        </h2>
                      </a>
                    </div>
                    <div
                      className={cn(
                        "growth__item growth__item--2",
                        initPage === 2 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={(e) => setCurrentPage({ status: true, el: 2 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-2.png"
                            srcSet="img/two/growth-2.png 1x, img/two/growth-2@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2013</span>
                        <h2 className="growth__title">
                          Объединение Avito, Slando и OLX
                        </h2>
                      </a>
                    </div>
                    <div
                      className={cn(
                        "growth__item growth__item--3",
                        initPage === 3 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: true, el: 3 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-3.png"
                            srcSet="img/two/growth-3.png 1x, img/two/growth-3@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2014</span>
                        <h2 className="growth__title">
                          От нового финансового директора до нового фирменного
                          знака
                        </h2>
                      </a>
                    </div>
                    <div
                      className={cn(
                        "growth__item growth__item--4",
                        initPage === 4 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: true, el: 4 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-4.png"
                            srcSet="img/two/growth-4.png 1x, img/two/growth-4@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>

                        <span className="growth__title-year">2015</span>
                        <h2 className="growth__title">
                          Участник площадки — вся страна
                        </h2>
                      </a>
                    </div>
                    <div
                      className={cn(
                        "growth__item growth__item--5",
                        initPage === 5 && "growth__item--active",
                        page && "growth__item--btn-close"
                      )}
                    >
                      <a
                        href="#"
                        className="growth__link"
                        onClick={() => setCurrentPage({ status: true, el: 5 })}
                      >
                        <div className="growth__img">
                          <img
                            src="img/two/growth-5.png"
                            srcSet="img/two/growth-5.png 1x, img/two/growth-5@2x.png 2x"
                            alt="img"
                            className="img"
                          />
                          <div className="growth__btn">Подробнее</div>
                        </div>
                        <span className="growth__title-year">2016</span>
                        <h2 className="growth__title">
                          Масштабные обновления: от доставки до приложения
                        </h2>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="growth__col">
                  <div className="growth__year">2016</div>
                </div>
              </div>
              {page && (
                <>
                  {initPage === 1 && (
                    <TwoPage1
                      setCurrentPage={setCurrentPage}
                      currentFooter={currentFooter}
                    />
                  )}
                  {initPage === 2 && (
                    <TwoPage2
                      setCurrentPage={setCurrentPage}
                      currentFooter={currentFooter}
                    />
                  )}
                  {initPage === 3 && (
                    <TwoPage3
                      setCurrentPage={setCurrentPage}
                      currentFooter={currentFooter}
                    />
                  )}
                  {initPage === 4 && (
                    <TwoPage4
                      setCurrentPage={setCurrentPage}
                      currentFooter={currentFooter}
                    />
                  )}
                  {initPage === 5 && (
                    <TwoPage5
                      setCurrentPage={setCurrentPage}
                      currentFooter={currentFooter}
                    />
                  )}
                </>
              )}
            </div>
          </div>
          <div className="section__footer">
            <Footer components="two" page={page} />
          </div>
        </div>
      </section>
    </>
  );
}

export default Two;
